import { compact } from 'lodash';

import { ActiveIngredientComposition } from '@dreryk/drerykweb-medicine-api';
import { VisitPrescription } from '@dreryk/egabinet-visit-frontend-api';

import { StyledHistoricalVisitBoldText } from './StyledHistoricalVisitBoldText';
import { StyledHistoricalVisitPrescriptionHeader } from './StyledHistoricalVisitPrescriptionHeader';

const NO_SPACE_SEPARATOR = '';
const SPACE_SEPARATOR = ' ';
const COMMA_SEPARATOR = ', ';
const SEMICOLON_SEPARATOR = '; ';

const mapActiveIngredientToDisplayableText = (activeIngredient: ActiveIngredientComposition): string => {
   const amount = compact([activeIngredient.nominalStrength, activeIngredient.unitName]).join(NO_SPACE_SEPARATOR);
   return compact([activeIngredient.name, amount]).join(SPACE_SEPARATOR);
};

type HistoricalVisitPrescriptionHeaderProps = Pick<VisitPrescription, 'name' | 'form' | 'packageContent'> & {
   readonly activeIngredients?: VisitPrescription['activeIngredients'];
};

export const HistoricalVisitPrescriptionHeader = (props: HistoricalVisitPrescriptionHeaderProps): JSX.Element => {
   const { activeIngredients = [] } = props;
   const formAndPackageContent = compact([props.form, props.packageContent]).join(SEMICOLON_SEPARATOR);
   const ingredients = activeIngredients.map(mapActiveIngredientToDisplayableText).join(COMMA_SEPARATOR);
   const details = compact([ingredients, formAndPackageContent]).join(SEMICOLON_SEPARATOR);

   return (
      <StyledHistoricalVisitPrescriptionHeader>
         <StyledHistoricalVisitBoldText>{props.name}</StyledHistoricalVisitBoldText>
         <span>{details}</span>
      </StyledHistoricalVisitPrescriptionHeader>
   );
};
